/* eslint-disable react/prop-types */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import swal from 'sweetalert';
import PropTypes from 'prop-types';
import { connect, useSelector, useDispatch } from 'react-redux';
import Title from '../../atoms/title/title';
import Select from '../../atoms/select/select';
import { mapDispatchToProps } from '../../../store/externalCalls/api/mainHubApi';
import './mainHubPageTitle.scss';
import { storeStructure } from '../../../store/reducers';
import { createSession } from '../../../store/actions/sessionActions';
import { useParams, useNavigate, useLocation, useOutletContext } from 'react-router-dom';

const MainHubPageTitle = (props) => {
  const {
    children,
    setConfigIdSession,
    disableArea,
    configFile,
  } = props;

  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const childRef = useRef();
  const contextLoaderData = useOutletContext() || {};
  const session = useSelector((state) => state[storeStructure.Session]);
  const [configValue, setConfigValue] = useState('');

  const areas = useSelector((state) => {
    const configs = state[storeStructure.mainHubConfigs];

    if (Array.isArray(configs)) {
      return configs.map((config) => ({
        name: config.name,
        value: config.id,
        id: config.id,
        slug: config.slug,
      }));
    }

    return [];
  });

  const currentConfigSlug = params.configSlug ?? session.configSlug ?? '';
  const currentConfig = areas.find(
    (config) => String(config.name) === String(currentConfigSlug)
  );

  const changeArea = (configId) => {
    const nextConfig = areas.find(
      (config) => String(config.id) === String(configId)
    );

    if (!nextConfig) return;
    const parts = location.pathname.split('/').filter(Boolean);
    const mhClientConfigIndex = parts.indexOf('mhClientConfig');
    if (mhClientConfigIndex !== -1 && parts[mhClientConfigIndex + 1]) {
      parts[mhClientConfigIndex + 1] = nextConfig.name;
    }
    dispatch(createSession({ configId: nextConfig.id, configSlug: nextConfig.name, mainHubId: contextLoaderData.mainHubId }));
    const url = `/${parts.join('/')}`;
    if (mhClientConfigIndex > 0)
      navigate(url, {
        state: {
          from: location.pathname,
        },
      });
  };
  const messageChangeArea = (previousConfigSlug, newConfigSlug) => {
    if (session.isBlocking) {
      swal({
        title: 'Wait',
        text: 'You have unsaved changes, are you sure you want to leave?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((ok) => {
        if (ok) {
          dispatch(createSession({ isBlocking: false }));
          changeArea(newConfigSlug);
        } else {
          setConfigValue(previousConfigSlug);
          if (childRef.current?.updateValue)
            childRef.current.updateValue(previousConfigSlug);
        }
      });
    } else {
      changeArea(newConfigSlug);
    }
  };

  const handlerOnChangeArea = (event) => {
    const newConfigSlug = event.target.value;
    messageChangeArea(currentConfigSlug, newConfigSlug);
  };

  return (
    <div>
      <Title>{children}</Title>
      <Select
        ref={childRef}
        className="page-title__select"
        id="mainhub-select"
        options={areas}
        value={contextLoaderData.currentConfigId || currentConfig?.id}
        onChange={handlerOnChangeArea}
        disabled={disableArea}
        writable={true}
      />
      <hr />
    </div>
  );
};

MainHubPageTitle.propTypes = {
  children: PropTypes.string.isRequired,
  setConfigIdSession: PropTypes.func.isRequired,
  disableArea: PropTypes.bool,
  configFile: PropTypes.shape({
    isSpaceMap: PropTypes.bool,
  }),
};

MainHubPageTitle.defaultProps = {
  disableArea: false,
  configFile: {},
};

export default connect(null, mapDispatchToProps)(MainHubPageTitle);